import { colors, fontSizes, fontWeights, spacings, responsiveBreakPoints } from '@styles/DesignVariables';
import styled from 'styled-components';

const { maxTablet } = responsiveBreakPoints;

export const AuthorContainer = styled.div`
	display: flex;
	padding: ${spacings.s24} ${spacings.s32};
	flex-direction: column;
	align-items: flex-start;
	gap: ${spacings.s8};
	border-radius: 5px;
	border: 1px solid #e0e0e0;
	background: ${colors.authorContainerBackground};
	@media screen and (${maxTablet}) {
		gap: ${spacings.s16};
	}
`;
export const AuthorBlock = styled.div`
	display: flex;
	flex-direction: row;
	gap: ${spacings.s16};

	img {
		height: 84px;
		width: 84px;
	}
`;
export const AuhtorInformation = styled.div`
	color: ${colors.blackText};
	font-size: ${fontSizes.largeParagraph};
	font-weight: ${fontWeights.normal};
	line-height: normal;
`;

export const AuthorBlockText = styled.div`
	color: ${colors.paragraphText};
	font-size: ${fontSizes.largeParagraph};
	font-weight: ${fontWeights.normal};
	line-height: 150%;
	margin-bottom: 0px !important;
	p:last-of-type {
		margin-bottom: 0;
	}
	@media screen and (${maxTablet}) {
		font-size: 16px;
	}
`;

export const AuthorWritten = styled.p`
	color: ${colors.blackText};
	font-size: ${fontSizes.largeParagraph};
	font-weight: ${fontWeights.normal};
	line-height: normal;
	margin: 0px !important;
	@media screen and (${maxTablet}) {
		margin-top: 4px !important;
	}
`;

export const AuthorName = styled.p`
	color: ${colors.blackText};
	font-size: ${fontSizes.largeParagraph};
	font-weight: ${fontWeights.bold};
	margin: ${spacings.s16} 0 0 0 !important;
	line-height: normal;
`;
